// height: calc(var(--vh, 1vh) * 100);
export default function trueVh() {
  let _lastInnerWidth = 0;
  let _vh = window.innerHeight * 0.01;

  const _trueVh = () => {
    if(_lastInnerWidth !== window.innerWidth) {
      _lastInnerWidth = window.innerWidth;
      _vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${_vh}px`);
    }
  }
  _trueVh();
  return _trueVh;
}




// WEBPACK FOOTER //
// ./scripts/library/_trueVh.js